<template>
   <t-config-provider :global-config="globalConfig" :key="rootKey + 'routerViewKey'" >
    <div id="app">
      <router-view  @onGlobalSwitchLang="onGlobalSwitchLang"   />
    </div>
</t-config-provider>
</template>

<script setup>
import { onBeforeUnmount, getCurrentInstance,ref } from "vue";
import { getSchoolList } from "@/api/login";
import { logout, getTenantIdDomain } from "@/api/login";
import { RouterLink, useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { getInfoInDividuation } from "@/api/Equipment.js";
import { flag } from "@/utils/handleUrl.js";
const { $eventBus } = getCurrentInstance().appContext.config.globalProperties;
const store = useStore();
const route = useRoute();
const router = useRouter();
import Cookies from "js-cookie";


import zhConfig from "tdesign-vue-next/es/locale/zh_CN";
import enConfig from "tdesign-vue-next/es/locale/en_US";
import jpConfig from "tdesign-vue-next/es/locale/ja_JP";
// TDesign全局国际化/多语言配置
const rootKey = ref(1999);
const globalConfig = ref();
rootKey.value++
const onGlobalSwitchLang = () => {
  if (window.g.LANG === "zh") {
    globalConfig.value = zhConfig;
  }else if (window.g.LANG === "ja") {
    globalConfig.value =jpConfig;
  }else{
    globalConfig.value =enConfig;
  }
  
  rootKey.value++;
};
onGlobalSwitchLang()
// 尝试从 Cookie 中获取 userInfo 字符串
const userInfoString = Cookies.get("userInfo");

// 尝试解析 userInfo 字符串为对象，如果解析失败则返回空对象
let initialUserInfo = {};
try {
  initialUserInfo = userInfoString ? JSON.parse(userInfoString) : {};
} catch (error) {
  console.error("Error parsing userInfo from Cookie:", error);
}

let schoolId = Cookies.get("schoolId");
let getToken = Cookies.get("tokenValue");

if (location.href.indexOf("/liveSharing") !== -1) {
  // 免登录页
} else {
  if (!store.getters.getSchoolId) {
    // location.host
    getSchoolList(location.host).then((res) => {
      if (res.code == 1) {
        if (res.data.length == 1) {
          store.commit("setSchoolId", res.data[0].id);
        }
      }
    });
    // getTenantIdDomain(window.location.host).then((res) => {
    //   if (res.code == 1 && res.data) {
    //     store.commit("setSchoolId", res.data);
    //   }
    // });
  }
}

const pfId = 2;
const getPlatForm = () => {
  if (schoolId) {
    let pathname = location.pathname;
    getInfoInDividuation(pfId, schoolId).then((res) => {
      if (res.code === 1) {
        window.document.title = res.data.name;
        sessionStorage.setItem("logingSeting",res.data.logingSeting); // 平台设置 个性化设置 登录设置 权限字段
        if (res.data) {
          // 平台一键置灰
          if (res.data.paltGrey == 1) {
            let html_box = document.getElementById("html_box");
            html_box.style.filter = "grayscale(100%)";
          } else {
            let html_box = document.getElementById("html_box");
            html_box.style.filter = "grayscale(0)";
          }

          // res.data.logingSeting == 3必须登录 ： mainjs 方法阻断在此之前执行了没有有效值所以无法有效阻断.  首次阻断逻辑在这里执行 ，之后刷新页面等操作在mainjs内阻断 未登录情况下
          if(res.data.logingSeting == 3 && !getToken && location.href.indexOf("/login") == -1){
            router.push({
              path: "/login",
            });
          }
        }
      }
    });
  }
};
getPlatForm();
// 监听平台个性化设置 平台一键置灰
$eventBus.on("getPlatFormDetail", () => {
  getPlatForm();
});

onBeforeUnmount(() => {
  // 移除监听事件
  $eventBus.off("getPlatFormDetail");
});
// getSchoolList(location.host).then((res) => {
//   if (res.code == 1) {
//     if (res.data.length == 1) {
//       store.commit("setSchoolId", res.data[0].id);
//     } else {
//       router.push({
//         path: "/login",
//       });
//     }
//   }
// });
</script>
<style lang="less">
#app {
  width: 100%;
  height: 100vh;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  outline: none !important;
}
.crxInfo {
  color: #ed7b2f;
}
</style>
